module.exports = __webpack_public_path__ + "media/application/images/svgs/message-circle-0e664cb7d9dab134bc011f382ecdf85d.svg";